import { apiClient } from './client'

/** A live camera of the case as a reader sees it: its stream's host only, never its credentials. */
export interface CameraDto {
  id: string
  name: string
  stream_host: string
  enabled: boolean
  segment_s: number
  /** When the camera agent last sent a picture, and the last segment; ISO 8601. */
  last_seen_at: string | null
  last_segment_at: string | null
  /** The recording the last segment became. */
  last_document_id: string | null
  /** Why recording last failed (the agent's words); null while it records. */
  last_error: string | null
  has_snapshot: boolean
}

export interface CamerasResponse {
  cameras: CameraDto[]
}

export interface CameraCreate {
  name: string
  stream_url: string
  segment_s: number
  enabled: boolean
}

export type CameraUpdate = Partial<CameraCreate>

const base = (caseId: string) => `/v1/cases/${caseId}/cameras`

export const camerasApi = {
  list: (caseId: string) => apiClient.get<CamerasResponse>(base(caseId)),
  create: (caseId: string, body: CameraCreate) => apiClient.post<CameraDto>(base(caseId), body),
  update: (caseId: string, cameraId: string, body: CameraUpdate) =>
    apiClient.patch<CameraDto>(`${base(caseId)}/${cameraId}`, body),
  remove: (caseId: string, cameraId: string) =>
    apiClient.delete<void>(`${base(caseId)}/${cameraId}`),
  /** The latest picture, fetched with the reader's token; `tick` defeats the browser's cache. */
  snapshotUrl: (caseId: string, cameraId: string, tick: number) =>
    `/api${base(caseId)}/${cameraId}/snapshot?t=${tick}`,
}
